import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  Input,
  OnDestroy,
  OnInit,
  ViewRef,
} from '@angular/core';
import { DatePipe } from '@angular/common';
import { FormControl, ReactiveFormsModule } from '@angular/forms';

import { MatIconModule } from '@angular/material/icon';
import {
  MatAutocomplete,
  MatAutocompleteTrigger,
  MatOption,
} from '@angular/material/autocomplete';

import { debounceTime, Subject, takeUntil } from 'rxjs';

import { ESvgIcons } from 'src/app/core/enums/svg-icons';
import { BookFlightFormSearchFlight } from 'src/app/shared/interfaces/book-flights';

import { CutStrPipe } from 'src/app/shared/pipes/cut-str.pipe';
import { SafeUrlPipe } from 'src/app/shared/pipes/safe-url.pipe';

import { PackageService } from 'src/app/core/services/package.service';
import { BreakpointService } from 'src/app/core/services/breakpoint.service';
import { GoogleAnalyticService } from 'src/app/core/services/google-analytic.service';

import moment from 'moment';

@Component({
  selector: 'app-book-flights-link',
  templateUrl: './book-flights-link.component.html',
  styleUrls: ['./book-flights-link.component.scss'],
  imports: [
    MatIconModule,
    DatePipe,
    CutStrPipe,
    MatAutocomplete,
    MatAutocompleteTrigger,
    ReactiveFormsModule,
    MatOption,
    SafeUrlPipe,
  ],
})
export class BookFlightsLinkComponent
  implements OnInit, AfterViewInit, OnDestroy
{
  @Input() itineraryItem: any;
  @Input() inDown = false;

  readonly eSvgIcons = ESvgIcons;
  readonly searchForm = new FormControl('');

  startDate: Date = new Date();
  startInGroup: Array<any> = [];
  bookFlightFormSearchFlight: BookFlightFormSearchFlight;

  readonly kiwiLink: string =
    'https://www.kiwi.com/deep?affilid=routeperfectltdrouteperfectdeeplink&departure=anytime&pageName=tilesPage&return=anytime';
  private readonly destroy$: Subject<boolean> = new Subject<boolean>();

  constructor(
    public readonly packageService: PackageService,
    private readonly googleAnalyticService: GoogleAnalyticService,
    protected readonly breakpointService: BreakpointService,
    private readonly cdr: ChangeDetectorRef,
  ) {
    this.bookFlightFormSearchFlight = new BookFlightFormSearchFlight();
  }

  ngOnInit(): void {
    this.bookFlightFormSearchFlight.term = '';

    this.packageService.autoCompleteStartResults
      .pipe(takeUntil(this.destroy$))
      .subscribe((data) => {
        if (data) {
          this.startInGroup = data;
        }
      });

    this.packageService.tripFlightsValue
      .pipe(takeUntil(this.destroy$))
      .subscribe((tripFlights) => {
        if (tripFlights && tripFlights.length > 0) {
          this.bookFlightFormSearchFlight.term =
            tripFlights[0].outbound.segment[0].departure.city;
          this.startDate = moment('2024-12-16', 'YYYY-MM-DD').toDate();
          this.searchForm.setValue(this.bookFlightFormSearchFlight.term);
          this.detectViewChanges();
        }
      });

    this.searchForm.valueChanges
      .pipe(debounceTime(500), takeUntil(this.destroy$))
      .subscribe((value: string) => {
        this.packageService.getStartCityAutocomplete(value);
        this.detectViewChanges();
      });
  }

  ngAfterViewInit() {
    this.detectViewChanges();
  }

  ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.complete();
    this.cdr.detach();
  }

  clickSearchFlight() {
    if (this.bookFlightFormSearchFlight.airport) {
      this.packageService.createNewPackage(
        this.startDate,
        'moderate',
        this.bookFlightFormSearchFlight.airport,
        (packageResponse) => console.log(packageResponse),
      );

      this.packageService.disableSearchButtonStatus = true;
    }
  }

  clickBookFLight() {
    const flights = this.packageService?.tripFlights[0];

    this.googleAnalyticService.setBookFlightAnalytic({
      flightFrom: flights.outbound.segment[0].flightnumber.toString(),
      flightTo:
        flights.outbound.segment[
          flights.outbound.segment.length - 1
        ].arrival.city.toString(),
    });
  }

  clickShowMore() {
    this.googleAnalyticService.setBookFlightShowMoreAnalytic();
  }

  addStartIn(item: any): void {
    this.bookFlightFormSearchFlight.term =
      item && item.name ? item.name.trim() : '';
    this.bookFlightFormSearchFlight.airport =
      item && item.code ? item.code : '';

    this.resetStartInGroup();
    this.packageService.disableSearchButtonStatus =
      !this.bookFlightFormSearchFlight.term.length;
  }

  resetStartInGroup(): void {
    this.startInGroup = [];
  }

  private detectViewChanges(): void {
    this.cdr.markForCheck();

    if (!(this.cdr as ViewRef).destroyed) {
      this.cdr.detectChanges();
    }
  }
}
